var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{class:['container', { 'with-margin': _vm.showingSidebar && !_vm.temporarySidebar }]},[_c('v-slide-x-transition',{attrs:{"mode":"out-in"}},[(_vm.feature)?_c('v-value-mapper'):_c('v-messages')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }